import { Dispatch, State } from 'model/State';
import { polling } from 'util/mac/api/account/poll';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { downloadLicensesOverviewCSV } from 'util/mac/downloadCSV';
import {
  END_USER_CSV_DOWNLOAD_IN_PROGRESS,
  END_USER_CSV_DOWNLOAD_IS_MIGRATION_IN_PROGRESS,
} from '../actions/accounts';

const MAX_POLLING_DURATION = 300000;
const POLLING_INTERVAL = 2000;

export const getDownloadCsvForEndUserLicenses = async (
  pollingUuid: string,
  isMigration: boolean,
  partnerId: string,
  state: State,
  dispatch: Dispatch,
) => {
  fetchWithParamValidation(
    async ({ id }) => {
      const remainingPath = `/getOverviewsAsync/poll/${id}`;

      const response = await polling(remainingPath, MAX_POLLING_DURATION, POLLING_INTERVAL, state);

      if (response?.overviews?.length > 0) {
        downloadLicensesOverviewCSV(response?.overviews, isMigration, partnerId);
      }

      if (isMigration) {
        dispatch({
          type: END_USER_CSV_DOWNLOAD_IS_MIGRATION_IN_PROGRESS,
          endUserCSVDownloadIsMigrationInProgress: false,
        });
      } else {
        dispatch({ type: END_USER_CSV_DOWNLOAD_IN_PROGRESS, endUserCSVDownloadInProgress: false });
      }
    },
    {
      id: pollingUuid,
    },
  );
};
